var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "school-box", on: { click: _vm.toSchoolLiveList } },
    [
      _c(
        "div",
        { staticClass: "school-info" },
        [
          _c("el-image", {
            staticClass: "school-logo",
            attrs: { src: _vm.schoolData.logo },
          }),
          _c("span", { staticClass: "school-name" }, [
            _vm._v(_vm._s(_vm.schoolData.name)),
          ]),
          _c("div", { staticClass: "live-count" }, [
            _vm._v(_vm._s(_vm.schoolData.live_num) + "场"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "school-location" }, [
        _c("i", { staticClass: "el-icon-location" }),
        _c("span", [_vm._v(_vm._s(_vm.schoolData.province))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }